export class LoanService {
  static getLoanNotification({ increaseNumber }) {
    return increaseNumber
      ? `С резерва списано на ${increaseNumber}₽ меньше ` +
          `из-за ограничения минимального лимита кабинета VK. `
      : ''
  }
}
